import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {deleteManyClips, deleteManyClipsFailure, deleteManyClipsSuccess} from './clip.delete-many.actions';
import {ClipsService} from '../../../services/api/clips/clips.service';
import {Clip} from '../../../services/api/clips/clip.model';
import {loadClips, manyClipsDeleted} from '../actions/clips.actions';


@Injectable()
export class ClipDeleteManyEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteManyClips$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyClips),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<Clip>[] = ids
            .map((id: UUID): Observable<Clip> => this.service.delete(id));

          return forkJoin(requests)
            .pipe(
              map(() => deleteManyClipsSuccess({ids: ids})),
              catchError((error: any) => of(deleteManyClipsFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyClipsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyClipsSuccess),
        tap(() =>
          this.snackBar.open('Clips successfully deleted', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyClipsDeleted({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyClipsFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyClipsFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to delete clips: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadClips())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: ClipsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
